import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@exiftrator/shared/components/ui';
import { cn } from '../../utils/cn';

function SettingsEditorDialog({
  open,
  onOpenChange,
  title,
  description,
  children,
  footer,
  contentClassName,
  bodyClassName,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        placement="top"
        className={cn(
          'w-[calc(100%-1rem)] max-w-5xl border-border-default bg-bg-secondary p-0 gap-0',
          'max-h-[90vh] overflow-hidden md:max-h-[80vh]',
          contentClassName,
        )}
      >
        <DialogHeader className="space-y-1 border-b border-border-subtle bg-bg-secondary px-5 py-4 text-left">
          <DialogTitle className="text-base font-semibold text-text-primary">{title}</DialogTitle>
          {description ? (
            <DialogDescription className="text-xs text-text-supporting">{description}</DialogDescription>
          ) : null}
        </DialogHeader>

        <div className={cn('overflow-y-auto px-5 py-5', bodyClassName)}>{children}</div>

        {footer ? (
          <div className="border-t border-border-subtle bg-bg-secondary px-5 py-4">{footer}</div>
        ) : null}
      </DialogContent>
    </Dialog>
  );
}

export default SettingsEditorDialog;
